import styled from 'styled-components';

interface ButtonProps {
    $borderColor?: string;
    $buttonHeight?: string;
    $skipBold?: boolean;
    $fontSize?: string;
    $color?: string;
    $textColor?: string;
    $hoverColor?: string;
    $hoverTextColor?: string;
}

export const Button = styled.button<ButtonProps>`
    font-family:
        UxumGrotesque,
        var(--font-uxum),
        -apple-system,
        BlinkMacSystemFont,
        Segoe UI,
        Roboto,
        Helvetica,
        Arial,
        sans-serif;

    line-height: 1em;
    display: block;
    width: 100%;
    border-radius: 3.125rem;
    cursor: pointer;
    border: ${(props) =>
        props.$borderColor ? `1px solid ${props.$borderColor}` : 'none'};

    height: ${(props) => props.$buttonHeight};
    font-weight: ${(props) => (props.$skipBold ? '' : 'bold')};
    font-size: ${(props) => props.$fontSize};

    overflow: hidden;
    position: relative;

    transition: all 0.3s ease;

    background: ${(props) => props.$color};
    color: ${(props) => props.$textColor};

    &:hover,
    &:focus {
        background: ${(props) => props.$hoverColor} !important;
        color: ${(props) => props.$hoverTextColor};
    }
`;

export const Img = styled.div<{
    $loadingHeight?: string | null;
    $loadingWidth?: string | null;
}>`
    width: ${(props) => (props.$loadingWidth ? props.$loadingWidth : '35px;')};
    height: ${(props) =>
        props.$loadingHeight ? props.$loadingHeight : '35px;'};
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    position: absolute;

    .rotate {
        animation: rotation 0.5s infinite linear;
    }

    @keyframes rotation {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(360deg);
        }
    }
`;

export const Icon = styled.div<{ $setIconRight?: boolean | null }>`
    display: flex;
    justify-content: center;

    svg {
        margin-right: ${(props) => (props.$setIconRight ? '0' : '0.5rem')};
        margin-left: ${(props) => (props.$setIconRight ? '0.5rem' : '0')};
    }

    p {
        margin: 0;
    }
`;

export const IconText = styled.p`
    display: flex;
    justify-content: center;
    align-items: center;
`;
